"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalculator = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _useCalculatorFields = require("./useCalculatorFields");
var _useMortgagePrograms = require("./useMortgagePrograms");
var _useAnalytics2 = require("./useAnalytics");
var _reactUtils = require("@cian/react-utils");
const _excluded = ["trackMortgageProgramClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useCalculator = () => {
  const fields = (0, _useCalculatorFields.useCalculatorFields)();
  const renderedPrograms = (0, _useMortgagePrograms.useMortgagePrograms)(fields);
  const _useAnalytics = (0, _useAnalytics2.useAnalytics)(fields),
    {
      trackMortgageProgramClick
    } = _useAnalytics,
    analyticHandlers = (0, _objectWithoutProperties2.default)(_useAnalytics, _excluded);
  const [selectedProgram, setSelectedProgram] = (0, _react.useState)();
  const selectProgram = (0, _react.useCallback)(program => {
    setSelectedProgram(program);
    trackMortgageProgramClick(program.id);
  }, [trackMortgageProgramClick]);
  const resetSelectedProgram = (0, _reactUtils.useEventCallback)(() => {
    setSelectedProgram(undefined);
  });
  return (0, _react.useMemo)(() => _objectSpread({
    fields,
    programs: renderedPrograms,
    selectedProgram,
    resetSelectedProgram,
    selectProgram
  }, analyticHandlers), [analyticHandlers, fields, renderedPrograms, resetSelectedProgram, selectProgram, selectedProgram]);
};
exports.useCalculator = useCalculator;